import { render, staticRenderFns } from "./SearchUpdate.vue?vue&type=template&id=b2015514"
import script from "./SearchUpdate.vue?vue&type=script&lang=js"
export * from "./SearchUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports